import MultChoiceObj from "../Models/QTypes/MultChoiceObj";
// import CheckboxObj from '../Models/QTypes/CheckboxObj';

const HR_QSet = [
  new MultChoiceObj({
    questionSet: {
      English:
        "Which best describes how you analyze workforce retention and measure joiners & leavers?",
    },
    answerSet: {
      English: [
        "Our process uses spreadsheet reports for tracking attrition and retention.",
        "Turnover and retention reports are created in standard BI tools.",
        "Attrition is tracked with our HCM system dashboards.",
        "Analytics system visualizes turnover drivers, with embedded ML to predict future attrition rates.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English:
        "Which best describes how you leverage predictive analytics for HR today?",
    },
    answerSet: {
      English: [
        "We perform basic (historical/transactional) HR reporting without predictive analysis.",
        "Ad hoc predictive modeling conducted as needed in spreadsheets.",
        "Predictive analysis with modeling done in a stand-alone analytics system.",
        "Predictive modeling capabilities are integrated within BI & Analytics systems.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English: "How do you forecast labor availability?",
    },
    answerSet: {
      English: [
        "We use spreadsheets to track availability and absences.",
        "Labor forecasts are in standard shared BI reports.",
        "Partially integrated forecasting done in dashboards based on past trend.",
        "Fully streamlined labor forecasting with predictive analytics and what-if scenario modeling.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English:
        "How do you correlate (what do you do to define or identify these groups) talent and compensation?",
    },
    answerSet: {
      English: [
        "We do not have a method for correlating top talent and compensation.",
        "We use manual solutions to analyze talent by department.",
        "We analyze talent performance at a corporate level.",
        "We leverage a unified analytics system to correlate compensation to top talent performance.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English: "How would you describe your HR data preparation process?",
    },
    answerSet: {
      English: [
        "A tedious, manual ETL process reliant on spreadsheets, completed by IT.",
        "Less manual, top-down process from IT with little input from affected HR departments.",
        "HR changes documented and standardized by IT, with some input from HR department teams.",
        "Enterprise-wide HR data management that’s integrated and on demand for any level of user.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English: "How do you enrich your HCM data with external data?",
    },
    answerSet: {
      English: [
        "We do not include external HR data today in our HR reporting.",
        "We leverage spreadsheets to bring together some external HR data.",
        "Our analytics system allows for ad hoc integration of HCM data with external data.",
        "External data is easily embedded with native connectors to extend our performance metrics in Analytics.",
      ],
    },
  }),
];

export default HR_QSet;
